import { IndexBrandComparisonChart } from "@/components/charts/Index/IndexBrandComparisonChart";
import { IndexKeyCitationSourcesChart } from "@/components/charts/Index/IndexKeyCitationSourcesChart";
import { IndexPlatformVisibilityChart } from "@/components/charts/Index/IndexPlatformVisibilityChart";
import { SearchPanelCard } from "@/components/SearchPanel";
import { useSearchIndexOptimized } from "@/hooks/useSearchIndexOptimized";
import { Button, Grid } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.less";

export const SearchIndex: React.FC = () => {
  const { t } = useTranslation();
  const vm = useSearchIndexOptimized();
  const screens = Grid.useBreakpoint();
  const isDesktop = !!screens.lg;

  return (
    <div className="search-index-page">
      <div className={`hero-section ${isDesktop ? "desktop" : "mobile"}`}>
        <div className={`hero-container ${isDesktop ? "desktop" : "mobile"}`}>
          <div className="hero-title-wrapper">
            <h1
              className={`home-brand-title hero-title ${isDesktop ? "desktop" : "mobile"}`}
            >
              {t("home.hero_title")}
            </h1>
          </div>
          <div className="search-panel-wrapper">
            <div
              className={`search-panel-container ${isDesktop ? "desktop" : "mobile"}`}
            >
              <SearchPanelCard
                value={vm.keyword}
                onChange={vm.setKeyword}
                rows={vm.rows}
                showRows={vm.rowsOpen}
                isLoading={vm.isLoading}
                error={vm.error}
                onRetry={() => vm.searchOnce()}
                onCloseRows={vm.onCloseRows}
                onSearch={vm.onSearch}
                onSelectRow={vm.onSelectRow}
                onFetchSuggestions={vm.searchOnce}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={`content-section ${isDesktop ? "desktop" : "mobile"}`}>
        {/* 三个分析容器 */}
        <div className={`analysis-grid ${isDesktop ? "desktop" : "mobile"}`}>
          {/* AI搜索表现分析 */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="card-inner">
              {/* 数据可视化图形区域（提取组件） */}
              <IndexPlatformVisibilityChart isDesktop={isDesktop} />

              {/* 内容区域 */}
              <div
                className={`card-content ${isDesktop ? "desktop" : "mobile"}`}
              >
                {/* 标题 */}
                <div
                  className={`card-title ${isDesktop ? "desktop" : "mobile"}`}
                >
                  {t("home.main_title")}
                </div>
                {/* 描述文字 */}
                <div
                  className={`card-description ${isDesktop ? "desktop" : "mobile"}`}
                >
                  {t("home.sub_title")}
                </div>
                <div
                  className={`tag-buttons-container ${isDesktop ? "desktop" : "mobile"}`}
                >
                  {[
                    t("home.tag_mentions"),
                    t("home.tag_recommendation"),
                    t("home.tag_reputation"),
                  ].map((button, index) => (
                    <Button
                      key={index}
                      size="small"
                      className={`tag-button ${isDesktop ? "desktop" : "mobile"}`}
                    >
                      {button}
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* 竞争态势分析 */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="card-inner">
              {/* 仪表板数据可视化区域（提取组件） */}
              <IndexBrandComparisonChart isDesktop={isDesktop} />

              {/* 内容区域 */}
              <div
                className={`card-content ${isDesktop ? "desktop" : "mobile"}`}
              >
                {/* 标题 */}
                <div
                  className={`card-title ${isDesktop ? "desktop" : "mobile"}`}
                >
                  {t("home.card_title_landscape")}
                </div>

                {/* 描述文字 */}
                <div
                  className={`card-description landscape ${isDesktop ? "desktop" : "mobile"}`}
                >
                  {t("home.card_desc_positioning")}
                </div>

                {/* 操作按钮 */}
                <div
                  className={`tag-buttons-container ${isDesktop ? "desktop" : "mobile"}`}
                >
                  {[
                    t("home.tag_positioning"),
                    t("home.tag_sov"),
                    t("home.tag_benchmark"),
                  ].map((button, index) => (
                    <Button
                      key={index}
                      size="small"
                      className={`tag-button ${isDesktop ? "desktop" : "mobile"}`}
                    >
                      {button}
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/* 引用来源识别 */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="card-inner">
              {/* 关键引用来源识别图表（组件化） */}
              <IndexKeyCitationSourcesChart isDesktop={isDesktop} />

              {/* 文本说明区域：保留标题与描述 */}
              <div
                className={`card-content ${isDesktop ? "desktop" : "mobile"}`}
              >
                <div
                  className={`card-title ${isDesktop ? "desktop" : "mobile"}`}
                >
                  {t("home.card_title_citation")}
                </div>
                <div
                  className={`card-description ${isDesktop ? "desktop" : "mobile"}`}
                >
                  {t("home.card_desc_source")}
                </div>
                {/* 操作按钮 */}
                <div
                  className={`tag-buttons-container ${isDesktop ? "desktop" : "mobile"}`}
                >
                  {[
                    t("home.tag_source_analysis"),
                    t("home.tag_weight"),
                    t("home.tag_strategy"),
                  ].map((button, index) => (
                    <Button
                      key={index}
                      size="small"
                      className={`tag-button ${isDesktop ? "desktop" : "mobile"}`}
                    >
                      {button}
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchIndex;
